import { useEffect, useState } from 'react';
import { MessageLayoutWrapper } from '../MessageMenu';
import { Stack } from 'components/Stack';

import AutoTablePart from './AutoTablePart';
import AutoMessagePart from './AutoMessagePart';
import { useSelectingRow } from '../common/CheckSelectStore';
import { useSingleAutoMessage } from './AutoStore';
import { useIsDifferenceStore } from '../common/MessagePromptStore';

import MessagePromptModal from '../common/MessagePromptModal';

export type TRequestFilter = {
  recipientType: string;
};

const MessageAutoPage = () => {
  const { setselectRow } = useSelectingRow();
  const { setSingleMessage } = useSingleAutoMessage();
  const { setIsDifference } = useIsDifferenceStore();

  const [requestFilter, setRequestFilter] = useState<TRequestFilter>({
    recipientType: 'all',
  });

  useEffect(() => {
    return () => {
      // url 강제 변경을 통해 다른 페이지로 이동시 초기화
      setselectRow('');
      setSingleMessage(null);
      setIsDifference(false);
    };
  }, []);
  return (
    <>
      <MessageLayoutWrapper useVerticalScroll>
        <Stack style={{ width: '60%', minWidth: '900px' }}>
          <AutoTablePart requestFilter={requestFilter} setRequestFilter={setRequestFilter} />
        </Stack>
        <Stack
          style={{
            width: '40%',
            minWidth: '649px',
            borderLeft: '2px solid rgb(216, 221, 234)',
          }}
        >
          <AutoMessagePart requestFilter={requestFilter} />
        </Stack>
      </MessageLayoutWrapper>
      <MessagePromptModal />
    </>
  );
};

export default MessageAutoPage;
